<template>
  <v-menu bottom left v-if="actions.length && $allow(actions.map((item) => item.akses).join('|'))">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" icon>
        <v-icon color="grey lighten-1">mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <template v-for="(action, i) in actions">
        <v-list-item :key="i" @click="onAction(action, data)" v-if="allow(action, data)">
          <v-list-item-icon style="margin-right: 8px">
            <v-icon v-text="action.icon" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-html="action.title" />
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'ListAction',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    actions: {
      type: Array,
      default: () => [],
    },
    allow: {
      type: Function,
    },
  },
  methods: {
    onAction(aksi, data) {
      this.$emit('action', { event: aksi, data });
    },
  },
};
</script>

<style scoped></style>
